import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MissingTranslationHandler, TranslateModule, TranslateService } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { TemplateMissingTranslationHandler } from "./translations/missing-translation-handler";
import { MarkdownModule, MarkedRenderer } from "ngx-markdown";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ContractDownloadComponent } from "./components/contract-download/contract-download.component";
import { DownloadContractService } from "./components/contract-download/download-contract.service";
import { LoaderComponent } from "./components/loader/loader.component";
import { LoginComponent } from "./components/login/login.component";
import { OkSignSuccessComponent } from "./components/ok-sign-success/ok-sign-success.component";
import { CredentialService } from "./credential.service";
import { AuthGuard } from "./guards/auth.guard";
import { LoginGuard } from "./guards/login.guard";
import { ApiService } from "./services/api.service";
import { MessageService } from "./services/message.service";
import { UserService } from "./services/user.service";
import { NavigationService } from "./shared/navigation.service";
import { TokenInterceptor } from "./interceptors/token.interceptor";
import { SharedModule } from "./shared/shared.module";
import { environment } from "../environments/environment";
import { LoaderInterceptor } from "./interceptors/loader.interceptor";
import { NgApexchartsModule } from "ng-apexcharts";
import { AzuressoComponent } from "./components/integrations/azuresso/azuresso.component";
import { NotifyService } from "./services/notify.service";

export const protectedResourceMap: [string, string[]][] = [["https://graph.microsoft.com/v1.0/me", ["user.read"]]];

const renderer = new MarkedRenderer();
renderer.link = ({ href, title, text }) => {
  return `<a href="${href}" target="_blank" rel="noopener noreferrer"${title ? ` title="${title}"` : ""}>${text}</a>`;
};

@NgModule({
  declarations: [AppComponent, LoginComponent, LoaderComponent, ContractDownloadComponent, OkSignSuccessComponent, AzuressoComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: provideTranslateHttpLoader({ prefix: environment.translationFileUrl, suffix: ".json" }),
      missingTranslationHandler: { provide: MissingTranslationHandler, useClass: TemplateMissingTranslationHandler }
    }),
    NgApexchartsModule,
    MarkdownModule.forRoot({})
  ],
  providers: [
    LoginGuard,
    UserService,
    ApiService,
    MessageService,
    TranslateService,
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true
    },
    DownloadContractService,
    CredentialService,
    NavigationService,
    NotifyService,
    provideHttpClient(withInterceptorsFromDi())
  ],
  exports: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
